import { Component, Input, Output, EventEmitter } from '@angular/core';
import { publicHelpers } from 'globals/helpers/public-helpers';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
@Component({
    selector: 'tip-text',
    template: `
  <div [class]="'holder ' + type">
    <strong class="head" *ngIf="!!head">{{ head }}</strong>&nbsp;
    <span class="text" 
      [ngClass]="{ hasClose: showClose }"
      [innerHTML]="helpers.strWithBreak(body)"></span>
    <icon class="close" [i18]="true" *ngIf="showClose" icon="close" (click)="close.emit()"></icon>
  </div>
`,
    styleUrls: ['tip-text.scss'],
    standalone: true,
    imports: [CommonModule, IconComponent],
})
export class TipTextComponent {
  helpers = publicHelpers
  @Input() head: string;
  @Input() body: string;
  @Input() showClose: boolean = false
  @Input() type: 'tip' | 'warn' | 'important' = 'tip';

  @Output() close: EventEmitter<void> = new EventEmitter()

}